import React from 'react';

const ZendeskLibraryActions = props => {
  const buttonClass =
    'NewButton NewButton--blue NewButton--center NewButton--tallAndWide';
  const { i18n, selectedItem, handleCancel, handleAddToLesson } = props;

  return (
    <div className="ElementLibrary-actions d-f jc-e ai-c mt-32 f-sh-0">
      <span
        role="button"
        tabIndex={0}
        onClick={handleCancel}
        className="c-p c-brand-gray-darker mr-24 h-td-u"
        onKeyDown={e => e.key === 'Enter' && handleCancel()}
      >
        {i18n.cancel}
      </span>
      {selectedItem && (
        <button
          type="button"
          className={buttonClass}
          onClick={handleAddToLesson}
        >
          {i18n.add}
        </button>
      )}
      {!selectedItem && (
        <button type="button" className={buttonClass} onClick={handleCancel}>
          {i18n.done}
        </button>
      )}
    </div>
  );
};

export default ZendeskLibraryActions;
